import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { getEnvironment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class SentryService {
    /**
     * Log an error to sentry
     * @param error Error
     * @param context Optional context
     */
    error(error: any, context?: { [key: string]: any; }): void {
        if (getEnvironment().sentry?.dsn) {
            Sentry.captureException(error, {
                extra: context || {},
            });
        }
    }

    /**
     * Log a message to sentry
     * @param message Message as string
     * @param context OPtional context
     */
    message(message: string, context?: { [key: string]: any; }): void {
        if (getEnvironment().sentry?.dsn) {
            Sentry.captureMessage(message, {
                level: 'info',
                extra: context || {},
            });
        }
    }
}
